import { render, staticRenderFns } from "./AddUniversity.vue?vue&type=template&id=31b64a6d&scoped=true&"
import script from "./AddUniversity.vue?vue&type=script&lang=js&"
export * from "./AddUniversity.vue?vue&type=script&lang=js&"
import style0 from "./AddUniversity.vue?vue&type=style&index=0&id=31b64a6d&prod&lang=scss&"
import style1 from "./AddUniversity.vue?vue&type=style&index=1&id=31b64a6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b64a6d",
  null
  
)

export default component.exports